// Normaliza y elimina los acentos
export function normalizeString(str: string, preserveSpaces = false): string {
  if (!str) return ''; // Asegura que no se procesen valores nulos o indefinidos
  let normalized = str.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Elimina acentos

  if (!preserveSpaces) {
    normalized = normalized.replace(/\s+/g, ''); // Elimina espacios internos si no se deben preservar
  }

  return normalized.toLowerCase().trim(); // Convierte a minúsculas y elimina espacios al inicio y al final
}